export default class Palette {

    static SGU_DARK_BLUE = "#2e4d9e"
    static SGU_LIGHT_BLUE = "#00adef"

}
